import { api } from "./api";

export const createStoreApi = (params) => {
    return api.post(`/store/create`, JSON.stringify(params));
};

export const editStoreApi = (params) => {
    return api.post(`/store/edit`, JSON.stringify(params));
};

export const listStoreApi = (params) => {
    return api.get(`/store/list`, { params });
};

export const viewStoreApi = (params) => {
    return api.get(`/store/view`, { params });
};

export const exportStoresApi = (params) => {
    return api.get(`/store/export`, { params });
};

export const uploadStoreImageApi = (params) => {
    return api.post(`/store/upload-image`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};